import { Country, CountryList } from "../classes/general/Country";

export const countries = new CountryList([
	new Country({
		name: "Åland Islands",
		code: "AX",
	}),

	new Country({
		name: "Albania",
		code: "AL",
	}),
	new Country({
		name: "Algeria",
		code: "DZ",
	}),
	new Country({
		name: "American Samoa",
		code: "AS",
	}),
	new Country({
		name: "Andorra",
		code: "AD",
	}),
	new Country({
		name: "Angola",
		code: "AO",
	}),
	new Country({
		name: "Anguilla",
		code: "AI",
	}),
	new Country({
		name: "Antigua and Barbuda",
		code: "AG",
	}),
	new Country({
		name: "Argentina",
		code: "AR",
	}),
	new Country({
		name: "Armenia",
		code: "AM",
	}),
	new Country({
		name: "Aruba",
		code: "AW",
	}),
	new Country({
		name: "Australia",
		code: "AU",
		requiredPostalCode: true,
	}),
	new Country({
		name: "Austria",
		code: "AT",
	}),
	new Country({
		name: "Azerbaijan",
		code: "AZ",
	}),
	new Country({
		name: "Bahamas",
		code: "BS",
	}),
	new Country({
		name: "Bahrain",
		code: "BH",
	}),
	new Country({
		name: "Bangladesh",
		code: "BD",
	}),
	new Country({
		name: "Barbados",
		code: "BB",
	}),
	new Country({
		name: "Belgium",
		code: "BE",
	}),
	new Country({
		name: "Belize",
		code: "BZ",
	}),
	new Country({
		name: "Benin",
		code: "BJ",
	}),
	new Country({
		name: "Bermuda",
		code: "BM",
	}),
	new Country({
		name: "Bhutan",
		code: "BT",
	}),
	new Country({
		name: "Bolivia",
		code: "BO",
	}),
	new Country({
		name: "Bosnia and Herzegovina",
		code: "BA",
	}),
	new Country({
		name: "Botswana",
		code: "BW",
	}),
	new Country({
		name: "Bouvet Island",
		code: "BV",
	}),
	new Country({
		name: "Brazil",
		code: "BR",
	}),
	new Country({
		name: "British Indian Ocean Territory",
		code: "IO",
	}),
	new Country({
		name: "British Virgin Islands",
		code: "VG",
	}),
	new Country({
		name: "Brunei",
		code: "BN",
	}),
	new Country({
		name: "Bulgaria",
		code: "BG",
	}),
	new Country({
		name: "Burkina Faso",
		code: "BF",
	}),
	new Country({
		name: "Burundi",
		code: "BI",
	}),
	new Country({
		name: "Cambodia",
		code: "KH",
	}),
	new Country({
		name: "Cameroon",
		code: "CM",
	}),
	new Country({
		name: "Canada",
		code: "CA",

		requiredPostalCode: true,
	}),
	new Country({
		name: "Cape Verde",
		code: "CV",
	}),
	new Country({
		name: "Caribbean Netherlands (Bonaire, Sint Eustatius, and Saba)",
		code: "BQ",
	}),
	new Country({
		name: "Cayman Islands",
		code: "KY",
	}),
	new Country({
		name: "Chad",
		code: "TD",
	}),
	new Country({
		name: "Chile",
		code: "CL",
	}),
	new Country({
		name: "China",
		code: "CN",
	}),
	new Country({
		name: "Christmas Island",
		code: "CX",
	}),
	new Country({
		name: "Cocos Islands",
		code: "CC",
	}),
	new Country({
		name: "Colombia",
		code: "CO",
	}),
	new Country({
		name: "Comoros",
		code: "KM",
	}),
	new Country({
		name: "Cook Islands",
		code: "CK",
	}),
	new Country({
		name: "Costa Rica",
		code: "CR",
	}),
	new Country({
		name: "Croatia",
		code: "HR",
	}),
	new Country({
		name: "Curaçao",
		code: "CW",
	}),
	new Country({
		name: "Cyprus",
		code: "CY",
	}),
	new Country({
		name: "Czechia (Czech Republic)",
		code: "CZ",
	}),
	new Country({
		name: "Côte d'Ivoire (Ivory Coast)",
		code: "CI",
	}),
	new Country({
		name: "Denmark",
		code: "DK",
	}),
	new Country({
		name: "Djibouti",
		code: "DJ",
	}),
	new Country({
		name: "Dominica",
		code: "DM",
	}),
	new Country({
		name: "Dominican Republic",
		code: "DO",
	}),
	new Country({
		name: "Ecuador",
		code: "EC",
	}),
	new Country({
		name: "Egypt",
		code: "EG",
	}),
	new Country({
		name: "El Salvador",
		code: "SV",
	}),
	new Country({
		name: "Equatorial Guinea",
		code: "GQ",
	}),
	new Country({
		name: "Eritrea",
		code: "ER",
	}),
	new Country({
		name: "Estonia",
		code: "EE",
	}),
	new Country({
		name: "Eswatini (Swaziland)",
		code: "SZ",
	}),
	new Country({
		name: "Ethiopia",
		code: "ET",
	}),
	new Country({
		name: "Falkland Islands",
		code: "FK",
	}),
	new Country({
		name: "Faroe Islands",
		code: "FO",
	}),
	new Country({
		name: "Fiji",
		code: "FJ",
	}),
	new Country({
		name: "Finland",
		code: "FI",
	}),
	new Country({
		name: "France",
		code: "FR",
		requiredPostalCode: true,
	}),
	new Country({
		name: "French Guiana",
		code: "GF",
	}),
	new Country({
		name: "French Polynesia",
		code: "PF",
	}),
	new Country({
		name: "French Southern and Antarctic Lands",
		code: "TF",
	}),
	new Country({
		name: "Gabon",
		code: "GA",
	}),
	new Country({
		name: "Gambia",
		code: "GM",
	}),
	new Country({
		name: "Georgia",
		code: "GE",
	}),
	new Country({
		name: "Germany",
		code: "DE",
		requiredPostalCode: true,
	}),
	new Country({
		name: "Ghana",
		code: "GH",
	}),
	new Country({
		name: "Gibraltar",
		code: "GI",
	}),
	new Country({
		name: "Greece",
		code: "GR",
	}),
	new Country({
		name: "Greenland",
		code: "GL",
	}),
	new Country({
		name: "Grenada",
		code: "GD",
	}),
	new Country({
		name: "Guadeloupe",
		code: "GP",
	}),
	new Country({
		name: "Guam",
		code: "GU",
	}),
	new Country({
		name: "Guatemala",
		code: "GT",
	}),
	new Country({
		name: "Guernsey",
		code: "GG",
	}),
	new Country({
		name: "Guinea",
		code: "GN",
	}),
	new Country({
		name: "Guinea-Bissau",
		code: "GW",
	}),
	new Country({
		name: "Guyana",
		code: "GY",
	}),
	new Country({
		name: "Heard Island and McDonald Islands",
		code: "HM",
	}),
	new Country({
		name: "Holy See (Vatican City)",
		code: "VA",
	}),
	new Country({
		name: "Honduras",
		code: "HN",
	}),
	new Country({
		name: "Hong Kong",
		code: "HK",
	}),
	new Country({
		name: "Hungary",
		code: "HU",
	}),
	new Country({
		name: "Iceland",
		code: "IS",
	}),
	new Country({
		name: "India",
		code: "IN",
		requiredPostalCode: true,
	}),
	new Country({
		name: "Indonesia",
		code: "ID",
	}),
	new Country({
		name: "Iraq",
		code: "IQ",
	}),
	new Country({
		name: "Ireland",
		code: "IE",
	}),
	new Country({
		name: "Isle of Man",
		code: "IM",
	}),
	new Country({
		name: "Israel",
		code: "IL",
	}),
	new Country({
		name: "Italy",
		code: "IT",
		requiredPostalCode: true,
	}),
	new Country({
		name: "Jamaica",
		code: "JM",
	}),
	new Country({
		name: "Japan",
		code: "JP",
	}),
	new Country({
		name: "Jersey",
		code: "JE",
	}),
	new Country({
		name: "Jordan",
		code: "JO",
	}),
	new Country({
		name: "Kazakhstan",
		code: "KZ",
	}),
	new Country({
		name: "Kenya",
		code: "KE",
	}),
	new Country({
		name: "Kiribati",
		code: "KI",
	}),
	new Country({
		name: "Korea (South Korea)",
		code: "KR",
	}),
	new Country({
		name: "Kosovo",
		code: "XK",
	}),
	new Country({
		name: "Kuwait",
		code: "KW",
	}),
	new Country({
		name: "Kyrgyzstan",
		code: "KG",
	}),
	new Country({
		name: "Lao People's Democratic Republic (Laos)",
		code: "LA",
	}),
	new Country({
		name: "Latvia",
		code: "LV",
	}),
	new Country({
		name: "Lebanon",
		code: "LB",
	}),
	new Country({
		name: "Lesotho",
		code: "LS",
	}),
	new Country({
		name: "Liberia",
		code: "LR",
	}),
	new Country({
		name: "Liechtenstein",
		code: "LI",
	}),
	new Country({
		name: "Lithuania",
		code: "LT",
	}),
	new Country({
		name: "Luxembourg",
		code: "LU",
	}),
	new Country({
		name: "Macao",
		code: "MO",
	}),
	new Country({
		name: "Madagascar",
		code: "MG",
	}),
	new Country({
		name: "Malawi",
		code: "MW",
	}),
	new Country({
		name: "Malaysia",
		code: "MY",
	}),
	new Country({
		name: "Maldives",
		code: "MV",
	}),
	new Country({
		name: "Malta",
		code: "MT",
	}),
	new Country({
		name: "Marshall Islands",
		code: "MH",
	}),
	new Country({
		name: "Martinique",
		code: "MQ",
	}),
	new Country({
		name: "Mauritania",
		code: "MR",
	}),
	new Country({
		name: "Mauritius",
		code: "MU",
	}),
	new Country({
		name: "Mayotte",
		code: "YT",
	}),
	new Country({
		name: "Mexico",
		code: "MX",
	}),
	new Country({
		name: "Micronesia",
		code: "FM",
	}),
	new Country({
		name: "Moldova",
		code: "MD",
	}),
	new Country({
		name: "Monaco",
		code: "MC",
	}),
	new Country({
		name: "Mongolia",
		code: "MN",
	}),
	new Country({
		name: "Montenegro",
		code: "ME",
	}),
	new Country({
		name: "Montserrat",
		code: "MS",
	}),
	new Country({
		name: "Morocco",
		code: "MA",
	}),
	new Country({
		name: "Mozambique",
		code: "MZ",
	}),
	new Country({
		name: "Namibia",
		code: "NA",
	}),
	new Country({
		name: "Nauru",
		code: "NR",
	}),
	new Country({
		name: "Nepal",
		code: "NP",
	}),
	new Country({
		name: "Netherlands",
		code: "NL",
		requiredPostalCode: true,
	}),
	new Country({
		name: "New Caledonia",
		code: "NC",
	}),
	new Country({
		name: "New Zealand",
		code: "NZ",
	}),
	new Country({
		name: "Niger",
		code: "NE",
	}),
	new Country({
		name: "Nigeria",
		code: "NG",
	}),
	new Country({
		name: "Niue",
		code: "NU",
	}),
	new Country({
		name: "Norfolk Island",
		code: "NF",
	}),
	new Country({
		name: "North Macedonia",
		code: "MK",
	}),
	new Country({
		name: "Northern Mariana Islands",
		code: "MP",
	}),
	new Country({
		name: "Norway",
		code: "NO",
	}),
	new Country({
		name: "Oman",
		code: "OM",
	}),
	new Country({
		name: "Pakistan",
		code: "PK",
	}),
	new Country({
		name: "Palau",
		code: "PW",
	}),
	new Country({
		name: "Palestinian territories",
		code: "PS",
	}),
	new Country({
		name: "Panama",
		code: "PA",
	}),
	new Country({
		name: "Papua New Guinea",
		code: "PG",
	}),
	new Country({
		name: "Paraguay",
		code: "PY",
	}),
	new Country({
		name: "Peru",
		code: "PE",
	}),
	new Country({
		name: "Philippines",
		code: "PH",
	}),
	new Country({
		name: "Pitcairn",
		code: "PN",
	}),
	new Country({
		name: "Poland",
		code: "PL",
	}),
	new Country({
		name: "Portugal",
		code: "PT",
	}),
	new Country({
		name: "Puerto Rico",
		code: "PR",
	}),
	new Country({
		name: "Qatar",
		code: "QA",
	}),
	new Country({
		name: "Republic of Congo",
		code: "CG",
	}),
	new Country({
		name: "Republic of Serbia",
		code: "RS",
	}),
	new Country({
		name: "Reunion",
		code: "RE",
	}),
	new Country({
		name: "Romania",
		code: "RO",
	}),
	new Country({
		name: "Rwanda",
		code: "RW",
	}),
	new Country({
		name: "Saint Barthélemy",
		code: "BL",
	}),
	new Country({
		name: "Saint Helena",
		code: "SH",
	}),
	new Country({
		name: "Saint Kitts and Nevis",
		code: "KN",
	}),
	new Country({
		name: "Saint Lucia",
		code: "LC",
	}),
	new Country({
		name: "Saint Martin",
		code: "MF",
	}),
	new Country({
		name: "Saint Pierre and Miquelon",
		code: "PM",
	}),
	new Country({
		name: "Saint Vincent and the Grenadines",
		code: "VC",
	}),
	new Country({
		name: "Samoa",
		code: "WS",
	}),
	new Country({
		name: "San Marino",
		code: "SM",
	}),
	new Country({
		name: "Saudi Arabia",
		code: "SA",
	}),
	new Country({
		name: "Senegal",
		code: "SN",
	}),
	new Country({
		name: "Seychelles",
		code: "SC",
	}),
	new Country({
		name: "Sierra Leone",
		code: "SL",
	}),
	new Country({
		name: "Singapore",
		code: "SG",
	}),
	new Country({
		name: "Sint Maarten",
		code: "SX",
	}),
	new Country({
		name: "Slovakia",
		code: "SK",
	}),
	new Country({
		name: "Slovenia",
		code: "SI",
	}),
	new Country({
		name: "Solomon Islands",
		code: "SB",
	}),
	new Country({
		name: "South Africa",
		code: "ZA",
	}),
	new Country({
		name: "South Georgia and the South Sandwich Islands",
		code: "GS",
	}),
	new Country({
		name: "Spain",
		code: "ES",
		requiredPostalCode: true,
	}),
	new Country({
		name: "Sri Lanka",
		code: "LK",
	}),
	new Country({
		name: "Suriname",
		code: "SR",
	}),
	new Country({
		name: "Svalbard and Jan Mayen",
		code: "SJ",
	}),
	new Country({
		name: "Sweden",
		code: "SE",
	}),
	new Country({
		name: "Switzerland",
		code: "CH",
	}),
	new Country({
		name: "São Tomé and Príncipe",
		code: "ST",
	}),
	new Country({
		name: "Taiwan",
		code: "TW",
	}),
	new Country({
		name: "Tajikistan",
		code: "TJ",
	}),
	new Country({
		name: "Tanzania",
		code: "TZ",
	}),
	new Country({
		name: "Thailand",
		code: "TH",
	}),
	new Country({
		name: "Timor-Leste",
		code: "TL",
	}),
	new Country({
		name: "Togo",
		code: "TG",
	}),
	new Country({
		name: "Tokelau",
		code: "TK",
	}),
	new Country({
		name: "Tonga",
		code: "TO",
	}),
	new Country({
		name: "Trinidad and Tobago",
		code: "TT",
	}),
	new Country({
		name: "Tunisia",
		code: "TN",
	}),
	new Country({
		name: "Türkiye (Turkey)",
		code: "TR",
	}),
	new Country({
		name: "Turkmenistan",
		code: "TM",
	}),
	new Country({
		name: "Turks and Caicos Islands",
		code: "TC",
	}),
	new Country({
		name: "Tuvalu",
		code: "TV",
	}),
	new Country({
		name: "U.S. Virgin Islands",
		code: "VI",
	}),
	new Country({
		name: "Uganda",
		code: "UG",
	}),
	new Country({
		name: "Ukraine",
		code: "UA",
	}),
	new Country({
		name: "United Arab Emirates",
		code: "AE",
		requiredRegion: true,
	}),
	new Country({
		name: "United Kingdom",
		code: "GB",
		requiredPostalCode: true,
	}),
	new Country({
		name: "United States",
		code: "US",
		requiredPostalCode: true,
	}),
	new Country({
		name: "United States Minor Outlying Islands",
		code: "UM",
	}),
	new Country({
		name: "Uruguay",
		code: "UY",
	}),
	new Country({
		name: "Uzbekistan",
		code: "UZ",
	}),
	new Country({
		name: "Vanuatu",
		code: "VU",
	}),
	new Country({
		name: "Vietnam",
		code: "VN",
	}),
	new Country({
		name: "Wallis and Futuna",
		code: "WF",
	}),
	new Country({
		name: "Western Sahara",
		code: "EH",
	}),
	new Country({
		name: "Zambia",
		code: "ZM",
	}),
]);
